import { render, staticRenderFns } from "./FractureCell.vue?vue&type=template&id=107b7b46&scoped=true&"
import script from "./FractureCell.vue?vue&type=script&lang=js&"
export * from "./FractureCell.vue?vue&type=script&lang=js&"
import style0 from "./FractureCell.vue?vue&type=style&index=0&id=107b7b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b7b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
